<div class="premium-modal-wrapper">
  <!-- Header Premium Blended -->
  <ion-header class="ion-no-border premium-header">
    <div class="header-curve"></div>
    <div class="custom-toolbar">
      <div class="toolbar-content">
        <div class="icon-btn" (click)="dismiss()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </div>
        <div class="title-group">
          <div class="title-main">{{ area.area || 'Detalle' }}</div>
          <div class="title-sub">{{ area.estructura || 'Inspección de Área' }}</div>
        </div>
        <div class="icon-btn" style="visibility: hidden;">
          <ion-icon name="close-outline"></ion-icon>
        </div>
      </div>
    </div>
  </ion-header>

  <ion-content class="light-bg" [scrollY]="true">
    <!-- Segment Selector (Glass Pill Style) -->
    <div class="tabs-container-premium">
      <div class="glass-tabs-pill">
        <ion-segment [(ngModel)]="segment" mode="md">
          <ion-segment-button value="medida">
            <ion-icon name="resize-outline"></ion-icon>
            <ion-label>CANTIDAD Y MEDIDAS</ion-label>
            <div class="segment-indicator-premium"></div>
          </ion-segment-button>
          <ion-segment-button value="foto">
            <ion-icon name="image-outline"></ion-icon>
            <ion-label>FOTOS</ion-label>
            <div class="segment-indicator-premium"></div>
          </ion-segment-button>
          <ion-segment-button value="nota">
            <ion-icon name="document-text-outline"></ion-icon>
            <ion-label>NOTAS</ion-label>
            <div class="segment-indicator-premium"></div>
          </ion-segment-button>
        </ion-segment>
      </div>
    </div>

    <div class="layout-wrapper">

      <!-- Main Data List -->
      <div class="data-content-wrapper fade-in">

        <!-- Skeleton Loader -->
        <div *ngIf="loading" class="section-group">
          <div class="premium-data-card" *ngFor="let i of [1,2,3]">
            <ion-skeleton-text animated style="width: 48px; border-radius: 14px; height: 48px;"></ion-skeleton-text>
            <div style="flex: 1;">
              <ion-skeleton-text animated style="width: 60%; height: 16px;"></ion-skeleton-text>
              <ion-skeleton-text animated style="width: 40%; height: 12px; margin-top: 8px;"></ion-skeleton-text>
            </div>
          </div>
        </div>

        <div *ngIf="!loading">
          <!-- Medidas Section -->
          <div *ngIf="segment === 'medida'" class="section-group">
            <div class="group-label">Medidas y Dimensiones</div>
            <div class="premium-data-card" *ngFor="let m of filteredDatos" (click)="editItem(m)">
              <div class="card-icon-box medida-bg">
                <ion-icon name="resize-outline"></ion-icon>
              </div>
              <div class="card-info-main">
                <div class="main-title">{{m.descripcion || 'Sin descripción'}}</div>
                <div class="sub-details">
                  <ng-container [ngSwitch]="m.tipo_medida">
                    <!-- Cuadrada -->
                    <div *ngSwitchCase="'cuadrada'" class="measure-row">
                      <span class="qty-badge-pure" *ngIf="m.cantidad > 1">{{m.cantidad}}x</span>
                      <span class="measure-txt">{{m.ancho}} x {{m.alto}} {{m.unidad}} = {{ (m.ancho * m.alto *
                        m.cantidad) | number:'1.2-2' }} {{m.unidad}}²</span>
                    </div>
                    <!-- Lineal -->
                    <div *ngSwitchCase="'lineal'" class="measure-row">
                      <span class="qty-badge-pure" *ngIf="m.cantidad > 1">{{m.cantidad}}x</span>
                      <span class="measure-txt">{{m.ancho}} {{m.unidad}} = {{ (m.ancho * m.cantidad) | number:'1.2-2' }}
                        {{m.unidad}}</span>
                    </div>
                    <!-- Unidad -->
                    <div *ngSwitchDefault class="measure-row">
                      <span class="qty-badge-pure">{{m.cantidad}}x</span>
                      <span class="measure-txt">{{m.unidad}}</span>
                    </div>
                  </ng-container>
                </div>
                <div class="note-line" *ngIf="m.comentario">
                  <ion-icon name="chatbox-ellipses-outline"></ion-icon>
                  <span>{{m.comentario}}</span>
                </div>
              </div>
              <div class="card-actions-end">
                <ion-button fill="clear" (click)="viewImage(m); $event.stopPropagation()" *ngIf="m.foto">
                  <ion-icon name="image-outline" color="primary" slot="icon-only"></ion-icon>
                </ion-button>
                <ion-button fill="clear" (click)="deleteItem(m); $event.stopPropagation()">
                  <ion-icon name="trash-outline" color="danger" slot="icon-only"></ion-icon>
                </ion-button>
              </div>
            </div>
          </div>

          <!-- Fotos Section -->
          <div *ngIf="segment === 'foto'" class="section-group">
            <div class="group-label">Evidencia Fotográfica</div>
            <div class="photo-grid-premium">
              <div class="photo-card-premium" *ngFor="let f of filteredDatos">
                <div class="card-img-container" (click)="viewImage(f)">
                  <img *ngIf="f.base64" [src]="f.base64" class="card-img" />
                  <div *ngIf="!f.base64" class="img-placeholder">
                    <ion-spinner *ngIf="f.loadingThumb" name="crescent" color="primary"></ion-spinner>
                    <ng-container *ngIf="!f.loadingThumb">
                      <ion-icon name="image-outline"></ion-icon>
                      <span>Sin Imagen</span>
                    </ng-container>
                  </div>
                </div>
                <div class="card-content-area">
                  <div class="photo-title">{{f.comentario || 'Imagen'}}</div>
                  <div class="photo-date" *ngIf="f.created_at">{{f.created_at | date:'dd/MM/yy HH:mm'}}</div>
                  <div class="photo-footer-actions">
                    <ion-button fill="clear" (click)="editItem(f); $event.stopPropagation()">
                      <ion-icon name="create-outline" slot="icon-only"></ion-icon>
                    </ion-button>
                    <ion-button fill="clear" (click)="deleteItem(f); $event.stopPropagation()">
                      <ion-icon name="trash-outline" color="danger" slot="icon-only"></ion-icon>
                    </ion-button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Notas y Estimados Section -->
          <div *ngIf="segment === 'nota'" class="section-group">
            <div class="group-label">Notas e Información Adicional</div>
            <div class="note-grid-premium">
              <div class="note-card-premium" *ngFor="let n of filteredDatos" (click)="editItem(n)"
                [class]="'cat-' + (n.tipo || 'default').toLowerCase()">

                <div class="card-header-badge">
                  {{n.tipo || (n.isEstimado ? 'ESTIMADO' : 'NOTA')}}
                </div>

                <div class="card-body-content">
                  <!-- Detalles por Tipo -->
                  <div class="detail-row" *ngIf="n.tipo === 'MOVILIDAD'">
                    <ion-icon name="construct-outline"></ion-icon>
                    <span>{{n.dias}} días combustible</span>
                  </div>

                  <div class="detail-row" *ngIf="n.tipo === 'PLANILLA'">
                    <ion-icon name="people-outline"></ion-icon>
                    <span>{{n.trabajadores}} trab. x {{n.dias}} d.</span>
                  </div>
                  <div class="detail-row" *ngIf="n.tipo === 'PLANILLA'">
                    <ion-icon name="time-outline"></ion-icon>
                    <span>{{n.turno}} (${{n.monto_diario}}/d)</span>
                  </div>

                  <div class="detail-row" *ngIf="n.tipo === 'SUBCONTRATO'">
                    <ion-icon name="business-outline"></ion-icon>
                    <span>{{n.subcontratista}}</span>
                  </div>

                  <div class="detail-row" *ngIf="n.tipo === 'MATERIAL'">
                    <ion-icon name="cube-outline"></ion-icon>
                    <span>Cant: {{n.cantidad}}</span>
                  </div>
                  <div class="detail-row" *ngIf="n.tipo === 'MATERIAL'">
                    <ion-icon name="cash-outline"></ion-icon>
                    <span>{{n.monto_diario | currency:'USD'}} unit.</span>
                  </div>

                  <!-- Chip de Costo Estimado -->
                  <div class="est-pill" *ngIf="n.isEstimado">
                    Est.: {{n.costo | currency:'USD'}}
                  </div>

                  <!-- Comentario/Nota -->
                  <div class="comment-row" *ngIf="n.comentario">
                    <ion-icon name="chatbox-ellipses-outline"></ion-icon>
                    <span>{{n.comentario}}</span>
                  </div>
                </div>

                <div class="card-footer-date">
                  {{n.created_at | date:'dd/MM/yy'}}
                </div>
              </div>
            </div>
          </div>

          <!-- Empty State -->
          <div class="empty-state-plus" *ngIf="filteredDatos.length === 0">
            <ion-icon name="add-circle-outline"></ion-icon>
            <p>No hay registros en esta sección</p>
          </div>
        </div>
      </div>

      <div class="spacer-bottom"></div>
    </div>
  </ion-content>

  <!-- Botón Flotante (FAB) Estándar pero Gris -->
  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button class="fab-btn premium-fab" (click)="onFabClick()">
      <ion-icon name="add-outline"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</div>